import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {tap} from "rxjs/operators";
import {AppStateService} from "../providers/app-state.service";
import {environment} from "../../environments/environment";
import {VetineoVisitTypeBundleDgSearchResults} from "../models/datagrid-search-results/vetineo-visit-type-bundle.dg-search-results.model";
import {VetineoVisitTypeBundleService} from "../providers/vetineo-visit-type-bundle.service";

@Injectable()
export class VetineoVisitTypeBundleResolve implements Resolve<VetineoVisitTypeBundleDgSearchResults> {
  constructor(private vetineoVisitTypeBundleService: VetineoVisitTypeBundleService, private appStateService: AppStateService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<VetineoVisitTypeBundleDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
    return this.vetineoVisitTypeBundleService.getResults(environment.DEFAULT_RESULTS_LIMIT, 0, 'ASC', 'created', false).pipe(tap(res => {
      this.appStateService.updateIsBusySubject(false);
    }));
  }
}
